import { ApiSluggedLink } from 'data-source/types.wp'

export function subscribeTagsMapper(input: {
  categories: ApiSluggedLink[]
  tags: ApiSluggedLink[]
}): readonly string[] {
  const tags = []
  for (const category of input.categories) {
    tags.push(category.name)
  }
  for (const tag of input.tags) {
    tags.push(tag.name)
  }
  return tags
}
